import { render } from "./App.vue?vue&type=template&id=b42729b0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b42729b0&lang=css"

import exportComponent from "D:\\VSCODE_POJECT\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__